import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { IBaseRequestParams } from '../../../../store/types/Request.types';

import { IGiftData } from './data.types';

const PREFIX = 'RECIPIENT/DATA';

export const dataLoadRequest = createAction<IBaseRequestParams>(`${PREFIX}/DATA_LOAD_REQUEST`);
export const dataLoadSuccess = createAction<IGiftData>(`${PREFIX}/DATA_LOAD_SUCCESS`);
export const dataLoadFail = createAction<TLegacyErrors>(`${PREFIX}/DATA_LOAD_FAIL`);

export const setShouldResetFlow = createAction<boolean>(`${PREFIX}/SET_SHOULD_RESET_FLOW`);

export const accessRequest = createAction<IBaseRequestParams>(`${PREFIX}/ACCESS_REQUEST`);
export const accessSuccess = createAction<void>(`${PREFIX}/ACCESS_SUCCESS`);
export const accessFail = createAction<TLegacyErrors>(`${PREFIX}/ACCESS_FAIL`);

export const applyMessageHeader = createAction<string>(`${PREFIX}/APPLY_MESSAGE_HEADER`);
